import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=70a0c341&scoped=true&"
import script from "./orderPage.vue?vue&type=script&lang=js&"
export * from "./orderPage.vue?vue&type=script&lang=js&"
import style0 from "./orderPage.vue?vue&type=style&index=0&id=70a0c341&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0c341",
  null
  
)

export default component.exports